import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GroupType } from '@libs/types/group.type';
import { VerificationType, VerificationTypeEnum } from '@libs/configs/component-configs/countdown.component-config';

@Component({
  selector: 'app-buttons-way-code',
  templateUrl: './buttons-way-code.component.html',
  styleUrls: ['./buttons-way-code.component.sass'],
})
export class ButtonsWayCodeComponent {
  @Input()
  public group: GroupType;

  @Input()
  public showPhone: boolean;

  @Output()
  public readonly wayRepeat: EventEmitter<VerificationType> = new EventEmitter<VerificationType>();
  protected readonly VerificationTypeEnum = VerificationTypeEnum;
}
